import {
    AfterViewInit,
    Component,
    Input,
    OnInit,
    ViewChild,
    ChangeDetectorRef,
    Output,
    EventEmitter,
} from '@angular/core';
import {FormGroup} from '@angular/forms';

import {FormFieldBase} from '../../../interfaces/form-field-base/form-field-base';
import {DynamicFormFieldService} from '../../../services/dynamic-form-field.service';
import {DynamicMenuFormFieldComponent} from '../../dynamic-form-field/dynamic-menu-form-field/dynamic-menu-form-field.component';
import {BehaviorSubject, combineLatest} from 'rxjs';
import {FlagKeys, LaunchDarklyService} from '@emm/core/services/launch-darkly.service';


@Component({
    selector: 'emm-dynamic-menu-form',
    templateUrl: './dynamic-menu-form.component.html',
    styleUrls: ['./dynamic-menu-form.component.scss'],
    standalone: false
})
export class DynamicMenuFormComponent implements OnInit, AfterViewInit {
    formFields: FormFieldBase<string>[] | null = [];
    formFields$ = new BehaviorSubject<FormFieldBase<string>[] | null>(null);
    @Input() item: any;
    @Input() itemTag: string;
    @Input() itemTagPath: string;
    @Input() selectedSubmenu: string;
    @Input() selectedFeatureScope: string;
    @Input() effectiveDate: string;
    @Input() nodeId: string;
    @Input() selectedLocation: string;
    @Input() form!: FormGroup;
    @Input() language: string;
    @Input() attributes: any;
    @Input() isReadOnly: any;
    @Input() existingUpdates: [];
    @Input() attributeGroupId: string;
    @Input() isCascade: boolean;
    @Output() removeLocalAttribute = new EventEmitter<FormFieldBase<string>>();
    @ViewChild(DynamicMenuFormFieldComponent) dynamicFormField: DynamicMenuFormFieldComponent<string>;

    model;
    thirdPartyPricingToggle$ = this.launchDarklyService.getBooleanFlag(FlagKeys.ENABLE_THIRD_PARTY_PRICING);
    removeMealFormfieldToggle$ = this.launchDarklyService.getBooleanFlag(FlagKeys.REMOVE_MEAL_FORMFIELD);

    constructor(
        public fieldService: DynamicFormFieldService,
        private changeDetector: ChangeDetectorRef,
        private launchDarklyService: LaunchDarklyService,
    ) {
    }

    ngOnInit() {}

    ngAfterViewInit() {
        if (!this.attributes) {
            return
        }
        combineLatest([
            this.removeMealFormfieldToggle$,
            this.thirdPartyPricingToggle$
        ]).subscribe(([removeMealFormfieldToggleValue, thirdPartyPricingToggleValue]) => {
            for (const attribute of this.attributes) {
                if (thirdPartyPricingToggleValue || attribute.jsonProperty !== 'thirdPartyDeliveryPrice') {
                    if ((removeMealFormfieldToggleValue && attribute.jsonProperty !== 'meal') &&
                        !this.formFields.some(formField => formField.jsonProperty === attribute.jsonProperty)) {
                        this.formFields.push(attribute);
                    } else if (removeMealFormfieldToggleValue && attribute.jsonProperty === 'meal') {
                        console.log('Skipping meal attribute');
                    } else {
                        this.formFields.push(attribute);
                    }
                }
            }
            this.formFields$.next(this.formFields);
            this.form = this.fieldService.toMenuFormGroup(
                this.formFields,
                this.isReadOnly,
                this.selectedFeatureScope,
                this.existingUpdates
            );
            this.model = this.form.value;
            this.changeDetector.detectChanges();
        });
    }

    hasChanges(): boolean {
        return this.form && this.form.dirty;
    }

    isFormReady(): boolean {
        return this.form && this.form.dirty && !this.form.invalid;
    }

    handleRemoveLocalAttribute(formField: FormFieldBase<string>) {
        this.removeLocalAttribute.emit(formField);
    }
}
